import React from "react";
import { SEO } from "../components/SEO";
import {
  getOrganizationSchema,
  getWebSiteSchema,
} from "../utils/structured-data";

import Hero from "./sections/Hero";
import TrustBar from "./sections/TrustBar";
import TwoWays from "./sections/TwoWays";
import Categories from "./sections/Categories";
import TalentGrid from "./sections/TalentGrid";
import HowItWorks from "./sections/HowItWorks";
import FAQ from "./sections/FAQ";
import FinalCTA from "./sections/FinalCTA";

export default function CBProHomePage() {
  return (
    <div className="bg-cream-100 text-ink-v2 antialiased">
      <SEO
        title="Hire Africa's top 5% freelance GTM talent"
        description="SDRs, account executives, RevOps analysts, lifecycle marketers and AI-native builders — hand-vetted, reference-checked, ready in days. Hire directly, or let us run the whole engagement."
        structuredData={[getOrganizationSchema(), getWebSiteSchema()]}
      />
      <Hero />
      <TrustBar />
      <TwoWays />
      <Categories />
      <TalentGrid />
      <HowItWorks />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
